/**
 * Fonte única do modal "Press F to check my music".
 *
 * Para publicar um lançamento novo basta acrescentar um objeto aqui — a
 * linha inteira (capa, infos e botão de compra) é montada a partir disso.
 *
 * `tab` diz em qual aba a linha entra e precisa bater com o id do container
 * no HTML: "self-releases" ou "labels".
 *
 * `label`, `year` e `style` sao opcionais: vazios, a linha some em vez
 * de mostrar um rotulo sem valor. Obrigatorios mesmo sao title, cover e url.
 *
 * A ordem da lista é a ordem na tela: hoje vai do mais recente para o mais
 * antigo, então um lançamento novo entra no topo.
 */
export const albums = [
  {
    tab: "self-releases",
    title: "Marta ‑ Nossas Histórias",
    year: "2025",
    style: "Beats, Instrumental, Hip Hop",
    cover: "/fotos/albums/nossas-historias.png",
    url: "https://martinelli.bandcamp.com/album/nossas-hist-rias",
  },
  {
    tab: "self-releases",
    title: "Martinelli ‑ Raw Cuts",
    year: "2023",
    style: "Techno",
    cover: "/fotos/albums/rawcuts.jpg",
    url: "https://martinelli.bandcamp.com/album/raw-cuts",
  },
  {
    tab: "self-releases",
    title: "Martinelli ‑ Minha Vida",
    year: "2023",
    style: "Electro, Techno, Acid",
    cover: "/fotos/albums/minha vida.jpg",
    url: "https://martinelli.bandcamp.com/album/minha-vida",
  },
  {
    tab: "self-releases",
    title: "Martinelli ‑ Programmin'",
    year: "2022",
    style: "Electro, Techno",
    cover: "/fotos/albums/programmin.jpg",
    url: "https://martinelli.bandcamp.com/album/programmin",
  },
  {
    tab: "self-releases",
    title: "Martinelli ‑ Ducentésimo Dia",
    year: "2020",
    style: "Techno",
    cover: "/fotos/albums/ducentesimo.jpg",
    url: "https://martinelli.bandcamp.com/album/ducent-simo-dia",
  },
  {
    tab: "self-releases",
    title: "Martinelli ‑ Talvez Numa Segunda Vinda",
    year: "2019",
    style: "Electro, Ambient, Techno",
    cover: "/fotos/albums/Talvez.jpg",
    url: "https://martinelli.bandcamp.com/album/talvez-numa-segunda-vinda",
  },
  {
    tab: "self-releases",
    title: "Martinelli ‑ NINE O'NINE",
    year: "2019",
    style: "Acid Techno, Acid, Techno",
    cover: "/fotos/albums/909.jpg",
    url: "https://martinelli.bandcamp.com/album/nine-0-nine",
  },
  {
    tab: "labels",
    title: "PERX",
    label: "Paradoxy",
    year: "2025",
    style: "Acid Techno, Electro, Breaks",
    cover: "/fotos/albums/perx.jpg",
    url: "https://paradoxy.bandcamp.com/album/perx",
  },
  {
    tab: "labels",
    title: "O Serviço",
    label: "Diffuse Reality",
    year: "2025",
    style: "",
    cover: "/fotos/albums/o-servico.jpg",
    url: "https://diffusereality.bandcamp.com/album/martinelli-o-servi-o",
  },
  {
    tab: "labels",
    title: "Teraflux",
    label: "Diffuse Reality",
    year: "2025",
    style: "",
    cover: "/fotos/albums/teraflux.jpg",
    url: "https://diffusereality.bandcamp.com/album/martinelli-teraflux",
  },
  {
    tab: "labels",
    title: "303 Bender",
    label: "Diffuse Reality",
    year: "2025",
    style: "",
    cover: "/fotos/albums/303-bender.jpg",
    url: "https://diffusereality.bandcamp.com/album/martinelli-303-bender-te0218",
  },
  {
    tab: "labels",
    title: "All The Voices",
    label: "Outermost Records",
    year: "2024",
    style: "Electro, Miami Bass, Ambient",
    cover: "/fotos/albums/all-the-voices.jpg",
    url: "https://outermost.bandcamp.com/album/all-the-voices",
  },
  {
    tab: "labels",
    title: "Martinelli ‑ Private Dealer",
    label: "Nice & Deadly",
    year: "2022",
    style: "Electro, Detroit Techno, TechnoBass",
    cover: "/fotos/albums/privatedealer.jpg",
    url: "https://martinelli.bandcamp.com/album/nd016-private-dealer",
  },
  {
    tab: "labels",
    title: "Voltags ‑ Chaos Center",
    label: "GATS",
    year: "2022",
    style: "",
    cover: "/fotos/albums/chaos-center.jpg",
    url: "https://ghostandthesong.bandcamp.com/track/fuck-the-president-martinelli-remix",
  },
  {
    tab: "labels",
    title: "Kengaral Eletrohits Vol. 1 & 2",
    label: "MambaRec",
    year: "2021",
    style: "Electro",
    cover: "/fotos/albums/kengaral.jpg",
    url: "https://mambarec.bandcamp.com/track/hud",
  },
  {
    tab: "labels",
    title: "Data Assault ‑ Black Earth EP",
    label: "Nice & Deadly",
    year: "2021",
    style: "Acid, Electro",
    cover: "/fotos/albums/black-earth.jpg",
    url: "https://nicendeadly.bandcamp.com/album/nd006-black-earth-ep",
  },
  {
    tab: "labels",
    title: "Negative Union (split 12\")",
    label: "Program And Control",
    year: "2021",
    style: "Electro",
    cover: "/fotos/albums/negative-union.jpg",
    url: "https://programandcontrol.bandcamp.com/album/negative-union-ep",
  },
  {
    tab: "labels",
    title: "Spiral Signals (12\")",
    label: "Abusive Records",
    year: "2021",
    style: "",
    cover: "/fotos/albums/spiral-signals.jpg",
    url: "https://abusiverecords.bandcamp.com/album/spiral-signs",
  },
  {
    tab: "labels",
    title: "Zona de Isolamento V.A",
    label: "Zona EXP.",
    year: "2020",
    style: "Electro",
    cover: "/fotos/albums/zona-isolamento.jpg",
    url: "https://zonaexp.bandcamp.com/track/take-me-to-the-bass",
  },
  {
    tab: "labels",
    title: "Perrelli ft. Nora ‑ Ai Que Raiva (Remixes)",
    label: "Zona EXP.",
    year: "2020",
    style: "Electro",
    cover: "/fotos/albums/ai-que-raiva.jpg",
    url: "https://zonaexp.bandcamp.com/album/perrelli-ft-nora-aiqueraiva-remixxx",
  },
  {
    tab: "labels",
    title: "UD004 V.A",
    label: "Under Division",
    year: "2020",
    style: "Techno",
    cover: "/fotos/albums/ud004.jpg",
    url: "https://underdivisionrecords.bandcamp.com/track/surprise",
  },
  {
    tab: "labels",
    title: "Sem Sono",
    label: "MambaRec",
    year: "2019",
    style: "",
    cover: "/fotos/albums/sem-sono.jpg",
    url: "https://mambarec.bandcamp.com/album/sem-sono",
  },
  {
    tab: "labels",
    title: "Plano Z",
    label: "Crobot Muzik",
    year: "2019",
    style: "Electro",
    cover: "/fotos/albums/plano-z.jpg",
    url: "https://crobotmuzik.bandcamp.com/album/martinelli-plano-z",
  },
  {
    tab: "labels",
    title: "Ferramentas Vol. I",
    label: "ODDiscos",
    year: "2019",
    style: "DJ Tools",
    cover: "/fotos/albums/ferramentas-vol-1.jpg",
    url: "https://oddiscos.bandcamp.com/album/ferramentas-vol-i-odd003",
  },
  {
    tab: "labels",
    title: "Radioworkers ‑ Dixava",
    label: "777 Recordings",
    year: "2018",
    style: "",
    cover: "/fotos/albums/dixava.jpg",
    url: "https://777recs.bandcamp.com/album/dixava-777-16",
  },
  {
    tab: "labels",
    title: "C Lacraia Estivesse Viva V.A",
    label: "Tormenta",
    year: "",
    style: "",
    cover: "/fotos/albums/c-lacraia.jpg",
    url: "https://clubetormenta.bandcamp.com/album/c-lacraia-estivesse-viva",
  },
  {
    tab: "labels",
    title: "From The UDG",
    label: "Hardwork Records",
    year: "",
    style: "",
    cover: "/fotos/albums/from-the-udg.jpg",
    url: "https://hardworkrecords.bandcamp.com/album/from-the-udg",
  },
];

/* As capas são todas quadradas e aparecem a 120px (ver .album-wrapper img no
   style.css). O width/height no <img> serve só de dica de proporção: sem ela
   a lista dá um pulo quando as imagens finalmente chegam. */
export const COVER_SIZE = 120;
